import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { formatPageTitle } from '@/lib/useDocumentTitle';

/**
 * Titre de l'onglet pour les routes STATIQUES (dont le libellé est connu sans
 * données). Les routes de CONTENU dynamique — examen, pratique, simulation —
 * ne sont pas listées ici : elles posent leur propre titre (nom de l'examen…)
 * via `useDocumentTitle` depuis leurs données, sur un rendu ultérieur, ce qui
 * l'emporte sur le titre par défaut posé ici à la navigation.
 */
const STATIC_TITLES: { test: (path: string) => boolean; title: string }[] = [
  { test: (p) => p === '/' || p === '/dashboard', title: 'Accueil' },
  { test: (p) => p.startsWith('/certifications'), title: 'Certifications' },
  { test: (p) => p === '/stats', title: 'Statistiques' },
  { test: (p) => p === '/leaderboard', title: 'Classement' },
  { test: (p) => p === '/profile', title: 'Profil' },
  { test: (p) => p.startsWith('/legal'), title: 'Mentions légales' },
  { test: (p) => p === '/plans', title: 'Abonnement' },
  { test: (p) => p === '/subscription', title: 'Mon abonnement' },
  { test: (p) => p.startsWith('/checkout'), title: 'Paiement' },
  { test: (p) => p.startsWith('/payment'), title: 'Paiement' },
  { test: (p) => p === '/verify-email', title: 'Confirmation de l’email' },
  { test: (p) => p === '/reset-password', title: 'Réinitialisation du mot de passe' },
  { test: (p) => p.startsWith('/admin'), title: 'Administration' },
];

export function DocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const match = STATIC_TITLES.find((r) => r.test(pathname));
    // Route de contenu dynamique non listée → titre par défaut ; la page posera
    // le titre précis (nom de l'examen) dès que ses données seront chargées.
    document.title = formatPageTitle(match?.title ?? null);
  }, [pathname]);
  return null;
}
